import CustomButton from "Components/Custom/CustomButton";
import CustomInput from "Components/Custom/CustomInput";
import { useAppSelector } from "Components/Hooks/hooks";
import { GlobalImage } from "config/image";
import { FormikProps } from "formik";
import { PersonalDetailsValues } from "pages/Settings/Cards/Profile";
import { useState } from "react";
import { Col, Row } from "reactstrap";
import { compressImage } from "utils/compressImage";
import { ErrorToast } from "utils/toast";

interface PersonalDetailsProps {
  validation: FormikProps<PersonalDetailsValues>;
  selectedFile: File | null;
  setSelectedFile: React.Dispatch<React.SetStateAction<File | null>>;
  isLoading?: boolean;
}

const PersonalDetails = ({
  validation,
  selectedFile,
  setSelectedFile,
  isLoading,
}: PersonalDetailsProps) => {
  const { user } = useAppSelector((state) => state?.auth);
  const [selectedImage, setSelectedImage] = useState<string>(
    user?.avatar ?? GlobalImage?.userPlaceHolder
  );

  console.log(user);

  const handleImageUpload = async (e: any) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    // Validate file type - only allow JPEG and PNG
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    const allowedExtensions = ["jpg", "jpeg", "png"];

    if (
      !allowedTypes.includes(file.type) &&
      !allowedExtensions.includes(fileExtension || "")
    ) {
      e.target.value = ""; // Reset the input
      ErrorToast("Only JPEG and PNG images are allowed");
      return;
    }

    const compressed = await compressImage(file);
    setSelectedFile(compressed);
    const previewUrl = URL.createObjectURL(compressed);
    setSelectedImage(previewUrl);
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    // Remove all non-digit characters
    const cleanValue = value.replace(/[^\d]/g, "");

    // Build the formatted value
    let formattedValue = "";
    if (cleanValue.length > 0) {
      // Add country code
      const countryCode = cleanValue.startsWith("44")
        ? cleanValue.substring(0, 2)
        : "44";
      const phoneNumber = cleanValue.startsWith("44")
        ? cleanValue.substring(2)
        : cleanValue;

      // Format as (+44) XXXXXXXXXX for display (with space)
      formattedValue = `(+${countryCode}) ${phoneNumber}`;
    }

    // Update formik with formatted value for display
    validation.setFieldValue("phone", formattedValue);
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
      }}
    >
      <Row>
        {/* IMAGE */}
        <div className="profile-img-container  d-flex justify-content-start">
          <div className="profile-img-wrapper position-relative d-inline-block">
            <div
              style={{
                width: 100,
                height: 100,
              }}
              className="profile-img rounded-circle overflow-hidden"
            >
              <img
                src={selectedImage}
                alt="Profile"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                onError={(e) => {
                  e.currentTarget.src = GlobalImage.userPlaceHolder;
                }}
              />
            </div>

            <label className="edit-profile-btn position-absolute bg-primary btn-press-effect">
              <i
                className="ri-pencil-fill text-white"
                style={{ fontSize: 18, marginTop: 2 }}
              />
              <input
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                style={{ display: "none" }}
              />
            </label>
          </div>
        </div>

        {/* User Details */}
        <Col md="12">
          <Row>
            <Col md="12" className="mb-1">
              <CustomInput
                label="Name"
                placeholder="Enter your name"
                type="text"
                name="name"
                value={validation.values.name}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                touched={validation.touched.name}
                error={validation.errors.name}
              />
            </Col>

            <Col md="6" className="mb-1">
              <CustomInput
                label="Email"
                placeholder="Enter your email"
                type="email"
                name="email"
                value={validation.values.email}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                touched={validation.touched.email}
                error={validation.errors.email}
                isDisabled={true}
              />
            </Col>

            <Col md="6" className="mb-1">
              <CustomInput
                label="Phone"
                placeholder="Enter your phone number"
                name="phone"
                type="text"
                value={validation.values.phone}
                onChange={handlePhoneChange}
                onBlur={validation.handleBlur}
                touched={validation.touched.phone}
                error={validation.errors.phone}
              />
            </Col>

            <Col md="12" className="mt-2">
              <CustomButton
                text="Update Profile"
                type="submit"
                className="bg-primary br-7"
                loading={isLoading}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </form>
  );
};

export default PersonalDetails;
